//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

import CheckCircle from 'assets/check-circle.svg';
import ErrorCircle from 'assets/exclamation-x-circle.svg';
import { ToastType } from 'contexts/ToastProvider';

/* restart / reset / upgrade 完成後的 toast,由 useSseEventTrigger 與 useSseHwTrigger 共用 */
export type ToastAction = 'restart' | 'reset' | 'upgrade';

export const createToastConfig = (isSuccess: boolean, action: ToastAction, t: (key: string) => string): ToastType => {
  const successTitleMap = {
    restart: t('toast.restartSuccessfully') || t('toast.success'),
    reset: t('toast.factoryResetSuccessful') || t('toast.success'),
    upgrade: t('modal.upgradeSuccessful') || t('toast.success'),
  };
  const failureTitleMap = {
    restart: t('toast.restartFailed') || t('toast.failed'),
    reset: t('toast.factoryResetFailed') || t('toast.failed'),
    upgrade: t('toast.upgradeFailed') || t('toast.failed'),
  };

  return {
    title: isSuccess ? successTitleMap[action] : failureTitleMap[action],
    message: '',
    color: isSuccess ? 'bg-toast-success-50' : 'bg-toast-error-50',
    icon: isSuccess ? CheckCircle : ErrorCircle,
    text: isSuccess ? 'text-toast-success-800' : 'text-toast-error-800',
    svg: isSuccess ? 'toastIcon-success' : 'toastIcon-error',
  };
};
